import {needAuth} from "../instance/Instance";
import {getToken} from "../../components/commonmethod/CommonMethod";
import {userLogout} from "../auth/AuthService";

const BASE_URL = import.meta.env.VITE_BASE_URL;

async function getLogs(size) {
    return await needAuth.get('/backup/logs?size='+size);
}

async function getDownloadAdminFile(type) {

    if(!window.confirm("다운로드 하시겠습니까?")){
        return;
    }

    let url = "/backup/db";
    if(type === "file"){
        url = "/backup/file";
    }else if(type === "log"){
        url = "/backup/log";
    }

    const token = getToken();
    let header ;
    let serverFileName;
    if(token != null){
        header = {
            'Content-Type': 'application/json',
            'Authorization' : `Bearer ${token}`
        }
    }else{
        alert("로그인 세션이 만료되어 로그아웃 되었습니다(1).")
        const response = await userLogout();
        window.location.replace("/");
        return response;
    }
    fetch(BASE_URL + url, {
        method: 'Get',
        headers: header
    })
        .then(response => {
            if (response.status === 202) {
                return response.json().then(data => {
                    alert(data.title + "\n" + data.reason);
                });
            } else if (response.ok) {
                const disposition = response.headers.get('Content-Disposition');
                let fileName = 'downloaded-file.xlsx';
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
                    if (matches != null && matches[1]) {
                        fileName = matches[1].replace(/['"]/g, '');
                    }
                }
                return response.blob().then(blob => ({ blob, fileName }));
            } else {
                throw new Error('파일 다운로드 실패: ' + response.statusText);
            }
        })
        .then(({ blob, fileName }) => {
            serverFileName = fileName;
            // Blob을 다운로드하기 위한 URL 생성
            const url = window.URL.createObjectURL(new Blob([blob]));
            // 다운로드 링크 생성
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName); // 파일명 설정
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);

            if(type !== "file") needAuth.get('/backup/delete?fileName='+encodeURIComponent(serverFileName));
        })
        .catch(error => console.error('파일 다운로드 중 오류 발생:', error))
}

export {getDownloadAdminFile, getLogs}